export default __webpack_public_path__ + "static/media/Avatar3.b71e6999.mp3";